import { gql } from 'graphql-request'

export const createAddonInvoice = gql`
  mutation CreateAddonInvoice($input: CreateAddonInvoiceInput!) {
    createAddonInvoice(input: $input) {
      invoiceId
    }
  }
`
